import { render, staticRenderFns } from "./Transfer.vue?vue&type=template&id=5c69bafa&scoped=true&lang=pug&"
import script from "./Transfer.vue?vue&type=script&lang=ts&"
export * from "./Transfer.vue?vue&type=script&lang=ts&"
import style0 from "./Transfer.vue?vue&type=style&index=0&id=5c69bafa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c69bafa",
  null
  
)

export default component.exports